import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { sendTeamMessageRoute } from '../api/constant';
import { profileKey } from '@staffedupusa/shared-components';

type useCreateTeamMessageProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useCreateTeamMessage = ({
  setErrorText = () => {},
}: useCreateTeamMessageProps) => {
  const client = useQueryClient();

  const { mutate: createTeamMessage, isLoading: isCreatingTeamMessage } =
    useMutation({
      mutationFn: (variables: {
        applicants_type?: number;
        user_ids?: number[];
        message?: string;
        token?: string;
        required_method?: number;
        positions?: (string | number)[];
        message_status?: boolean;
        extra_text?: boolean;
        allocated_texts?: any;
        amount?: number;
      }) =>
        axiosInstance
          .post(sendTeamMessageRoute, variables, {
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          client.invalidateQueries(profileKey);
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
    });

  return {
    createTeamMessage,
    isCreatingTeamMessage,
  };
};
